"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayInt64 = void 0;

var Stream_1 = require("../../stream/Stream");

var Converters_1 = require("../../check/arbitrary/definition/Converters");

var NextArbitrary_1 = require("../../check/arbitrary/definition/NextArbitrary");

var NextValue_1 = require("../../check/arbitrary/definition/NextValue");

var ArrayInt64_1 = require("./helpers/ArrayInt64");

var ArrayInt64Arbitrary = /*#__PURE__*/function (_NextArbitrary_1$Next) {
  _inherits(ArrayInt64Arbitrary, _NextArbitrary_1$Next);

  var _super = _createSuper(ArrayInt64Arbitrary);

  function ArrayInt64Arbitrary(min, max) {
    var _this;

    _classCallCheck(this, ArrayInt64Arbitrary);

    _this = _super.call(this);
    _this.min = min;
    _this.max = max;
    _this.biasedRanges = null;
    return _this;
  }

  _createClass(ArrayInt64Arbitrary, [{
    key: "generate",
    value: function generate(mrng, biasFactor) {
      var range = this.computeGenerateRange(mrng, biasFactor);
      var uncheckedValue = mrng.nextArrayInt(range.min, range.max);

      if (uncheckedValue.data.length === 1) {
        uncheckedValue.data.unshift(0);
      }

      return new NextValue_1.NextValue(uncheckedValue, undefined);
    }
  }, {
    key: "computeGenerateRange",
    value: function computeGenerateRange(mrng, biasFactor) {
      if (biasFactor === undefined || mrng.nextInt(1, biasFactor) !== 1) {
        return {
          min: this.min,
          max: this.max
        };
      }

      var ranges = this.retrieveBiasedRanges();

      if (ranges.length === 1) {
        return ranges[0];
      }

      var id = mrng.nextInt(-2 * (ranges.length - 1), ranges.length - 2);
      return id < 0 ? ranges[0] : ranges[id + 1];
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      var unsafeValue = value;
      return typeof value === 'object' && value !== null && (unsafeValue.sign === -1 || unsafeValue.sign === 1) && Array.isArray(unsafeValue.data) && unsafeValue.data.length === 2 && ((0, ArrayInt64_1.isStrictlySmaller64)(this.min, unsafeValue) && (0, ArrayInt64_1.isStrictlySmaller64)(unsafeValue, this.max) || (0, ArrayInt64_1.isEqual64)(this.min, unsafeValue) || (0, ArrayInt64_1.isEqual64)(this.max, unsafeValue));
    }
  }, {
    key: "shrinkArrayInt64",
    value: function shrinkArrayInt64(value, target, tryTargetAsap) {
      var _marked = /*#__PURE__*/_regeneratorRuntime.mark(shrinkGen);

      var realGap = (0, ArrayInt64_1.substract64)(value, target);

      function shrinkGen() {
        var previous, gap, toremove, next;
        return _regeneratorRuntime.wrap(function shrinkGen$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                previous = tryTargetAsap ? undefined : target;
                gap = tryTargetAsap ? realGap : (0, ArrayInt64_1.halve64)(realGap);
                toremove = gap;

              case 3:
                if ((0, ArrayInt64_1.isZero64)(toremove)) {
                  _context.next = 11;
                  break;
                }

                next = (0, ArrayInt64_1.substract64)(value, toremove);
                _context.next = 7;
                return new NextValue_1.NextValue(next, previous);

              case 7:
                previous = next;

              case 8:
                toremove = (0, ArrayInt64_1.halve64)(toremove);
                _context.next = 3;
                break;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _marked);
      }

      return (0, Stream_1.stream)(shrinkGen());
    }
  }, {
    key: "shrink",
    value: function shrink(current, context) {
      if (!ArrayInt64Arbitrary.isValidContext(current, context)) {
        var target = this.defaultTarget();
        return this.shrinkArrayInt64(current, target, true);
      }

      if (this.isLastChanceTry(current, context)) {
        return Stream_1.Stream.of(new NextValue_1.NextValue(context, undefined));
      }

      return this.shrinkArrayInt64(current, context, false);
    }
  }, {
    key: "defaultTarget",
    value: function defaultTarget() {
      if (!(0, ArrayInt64_1.isStrictlyPositive64)(this.min) && !(0, ArrayInt64_1.isStrictlyNegative64)(this.max)) {
        return ArrayInt64_1.Zero64;
      }

      return (0, ArrayInt64_1.isStrictlyNegative64)(this.min) ? this.max : this.min;
    }
  }, {
    key: "isLastChanceTry",
    value: function isLastChanceTry(current, context) {
      if ((0, ArrayInt64_1.isZero64)(current)) {
        return false;
      }

      if (current.sign === 1) {
        return (0, ArrayInt64_1.isEqual64)(current, (0, ArrayInt64_1.add64)(context, ArrayInt64_1.Unit64)) && (0, ArrayInt64_1.isStrictlyPositive64)((0, ArrayInt64_1.substract64)(current, this.min));
      } else {
        return (0, ArrayInt64_1.isEqual64)(current, (0, ArrayInt64_1.substract64)(context, ArrayInt64_1.Unit64)) && (0, ArrayInt64_1.isStrictlyNegative64)((0, ArrayInt64_1.substract64)(current, this.max));
      }
    }
  }, {
    key: "retrieveBiasedRanges",
    value: function retrieveBiasedRanges() {
      if (this.biasedRanges != null) {
        return this.biasedRanges;
      }

      if ((0, ArrayInt64_1.isEqual64)(this.min, this.max)) {
        this.biasedRanges = [{
          min: this.min,
          max: this.max
        }];
        return this.biasedRanges;
      }

      var minStrictlySmallerZero = (0, ArrayInt64_1.isStrictlyNegative64)(this.min);
      var maxStrictlyGreaterZero = (0, ArrayInt64_1.isStrictlyPositive64)(this.max);

      if (minStrictlySmallerZero && maxStrictlyGreaterZero) {
        var logMin = (0, ArrayInt64_1.logLike64)(this.min);
        var logMax = (0, ArrayInt64_1.logLike64)(this.max);
        this.biasedRanges = [{
          min: logMin,
          max: logMax
        }, {
          min: (0, ArrayInt64_1.substract64)(this.max, logMax),
          max: this.max
        }, {
          min: this.min,
          max: (0, ArrayInt64_1.substract64)(this.min, logMin)
        }];
      } else {
        var logGap = (0, ArrayInt64_1.logLike64)((0, ArrayInt64_1.substract64)(this.max, this.min));
        var arbCloseToMin = {
          min: this.min,
          max: (0, ArrayInt64_1.add64)(this.min, logGap)
        };
        var arbCloseToMax = {
          min: (0, ArrayInt64_1.substract64)(this.max, logGap),
          max: this.max
        };
        this.biasedRanges = minStrictlySmallerZero ? [arbCloseToMax, arbCloseToMin] : [arbCloseToMin, arbCloseToMax];
      }

      return this.biasedRanges;
    }
  }], [{
    key: "isValidContext",
    value: function isValidContext(_current, context) {
      if (context === undefined) {
        return false;
      }

      if (typeof context !== 'object' || context === null || !('sign' in context) || !('data' in context)) {
        throw new Error("Invalid context type passed to ArrayInt64Arbitrary (#1)");
      }

      return true;
    }
  }]);

  return ArrayInt64Arbitrary;
}(NextArbitrary_1.NextArbitrary);

function arrayInt64(min, max) {
  var arb = new ArrayInt64Arbitrary(min, max);
  return (0, Converters_1.convertFromNextWithShrunkOnce)(arb, arb.defaultTarget());
}

exports.arrayInt64 = arrayInt64;